import { createColDef } from '@fortem-monorepo/react-ag'

import { ContractTypeCellEditor } from '@/ag-grid/columns/contract-type/cell-editor'
import { ContractTypeCellRenderer } from '@/ag-grid/columns/contract-type/renderer'

export const contract_type = createColDef({
  field: 'contract_type',
  headerName: 'Contract Type',
  cellRenderer: ContractTypeCellRenderer,
  cellEditor: ContractTypeCellEditor,
  width: 150,
})
